import React from 'react';
import StatsCard from './StatsCard';

const DashboardHeader = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatsCard 
        title="Vehículos totales" 
        value={stats.vehicles ?? "—"} 
        icon="🚗"
      />
      <StatsCard 
        title="Disponibles" 
        value={stats.available ?? "—"} 
        icon="✅"
        trend={{ value: "+2", text: "este mes", color: "text-green-600" }}
      />
      <StatsCard 
        title="En mantenimiento" 
        value={stats.maintenance ?? "—"} 
        icon="🔧"
        trend={{ value: "-1", text: "este mes", color: "text-red-600" }}
      />
      <StatsCard 
        title="Kilometraje promedio" 
        value={stats.avgKm ? `${stats.avgKm} km` : "—"} 
        icon="📊"
      />
    </div>
  );
};

export default DashboardHeader;